import axios from "axios";

axios.defaults.baseURL = "https://blockchaincapitalizer.com";
// axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(async (request) => {
  const token = window.localStorage.getItem("token");

  request.headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    request.headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return request;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // if (error.response?.status === 403) {
    //   window.location.href = "/forbidden";
    // }
    if (error.response?.status === 401) {
      window.localStorage.removeItem("token");
      window.location.href = "/";
    }

    throw error;
  },
);

export default axios;
